import * as firebase from 'firebase';
import 'firebase/firestore';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyAj8Ze8z3ZXZoCCLHPVZWjy5ZeAh17Worg",
    authDomain: "treasure-x.firebaseapp.com",
    databaseURL: "https://treasure-x.firebaseio.com",
    projectId: "treasure-x",
    storageBucket: "",
    messagingSenderId: "883638435622"
});

const auth = firebaseApp.auth(); 
const db = firebaseApp.firestore();

export { db, auth };


// WEBPACK FOOTER //
// ./src/util/firebase.js